import { FC, useId, useState } from 'react';
import {
	StyledFullContainer,
	StyledHoverGlow
} from 'src/styles/theme/components/NGGoldContainer/NGGoldContainer.styles';
import NGIcon from 'src/styles/theme/components/NGIcon';
import { ESize, ETextColor, EThemeColor } from 'src/styles/theme/utils/enums';
import { StyledNGSquareButton } from './NGSquareButton.styles';
import { INGSquareButton } from './NGSquareButton.type';

const NGSquareButton: FC<INGSquareButton> = ({
	onClick,
	icon,
	size = ESize.m,
	color = ETextColor.gold,
	disabled = false,
	isHidden = false,
	children,
	...otherProps
}) => {
	const glowContainerUuid = useId();

	const [isGlowVisible, setIsGlowVisible] = useState(false);
	const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

	const onMouseEnter = () => {
		try {
			// @ts-ignore
			clearTimeout(window[`timer-${glowContainerUuid}`]);
		} catch {
			// fallback
		}

		setIsGlowVisible(true);
	};

	const onMouseLeave = () => {
		try {
			// @ts-ignore
			window[`timer-${glowContainerUuid}`] = setTimeout(() => {
				setIsGlowVisible(false);
			}, 100);
		} catch (err) {
			console.error(err);
		}
	};

	const onMouseMove = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		const parent = document.getElementById(glowContainerUuid);

		const { left, top } = parent?.getBoundingClientRect() || {};

		if (!left || !top) {
			return;
		}

		setMousePos({ x: e.clientX - left, y: e.clientY - top });
	};

	const position = {
		left: `${mousePos.x}px`,
		top: `${mousePos.y}px`
	};

	return (
		<StyledNGSquareButton
			onClick={!!onClick ? onClick : undefined}
			size={size}
			disabled={disabled}
			containsChildren={!!children}
			isHidden={isHidden}
			onMouseMove={onMouseMove}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			colorVariant={EThemeColor.gold}
			{...otherProps}
		>
			{!disabled ? (
				<StyledFullContainer as='span' id={glowContainerUuid}>
					<StyledHoverGlow isVisible={isGlowVisible} style={position} colorVariant={EThemeColor.gold} />
				</StyledFullContainer>
			) : null}

			{typeof children === 'undefined' ? <NGIcon type={icon} color={color} /> : children}
		</StyledNGSquareButton>
	);
};

export { NGSquareButton };
